var render = function (_h,_vm) {var _c=_vm._c;return _c('v-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(
    _vm.props.department.name
      ? '所管部門：' + _vm.props.department.name
      : '所管部門：未指定'
  ),expression:"\n    props.department.name\n      ? '所管部門：' + props.department.name\n      : '所管部門：未指定'\n  "}],staticClass:"ml-2",attrs:{"x-small":""},domProps:{"textContent":_vm._s('feather-users')}})}
var staticRenderFns = []

export { render, staticRenderFns }